import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash';

import { useTrappedFocus } from 'shared/hocs/useTrappedFocus';

import theme from './Modal.scss';

const propTypes = {
  testId: PropTypes.string,
  Component: PropTypes.func.isRequired,
  typeId: PropTypes.number,
  onOk: PropTypes.func,
  onDismiss: PropTypes.func,
  onCancel: PropTypes.func,
  rtl: PropTypes.bool,
};

const defaultProps = {
  testId: '',
  typeId: null,
  onOk: noop,
  onDismiss: noop,
  onCancel: noop,
  rtl: false,
};

const Modal = ({ rtl, Component, testId, ...rest }) => {
  const focusContainerRef = useTrappedFocus();

  const handleOverlayClick = () => {
    rest.onDismiss();
  };

  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  return (
    <div className={ classnames(theme.root, theme.fadeIn) } data-testid={ testId } tabIndex="-1">
      <div
        aria-hidden="true"
        className={ theme.overlay }
        onClick={ handleOverlayClick }
      />
      <div
        className={ classnames(theme.container, { rtl }) }
        onClick={ handleModalClick }
        ref={ focusContainerRef }
      >
        <Component { ...rest } />
      </div>
    </div>
  );
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default memo(Modal);
